import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import { Router } from '@angular/router';
import { CrudFieldsService } from 'src/app/components/crud-fields/crud-fields.service';
import { NoticeComponent } from 'src/app/components/notice/notice.component';
import { DataService } from 'src/app/services/data/data.service';

@Component({
  selector: 'app-dialog-import-fields',
  templateUrl: './dialog-import-fields.component.html',
  styleUrls: ['./dialog-import-fields.component.scss']
})
export class DialogImportFieldsComponent{
    public dados: any = []
    public fields: any = []
    public payload: object
    public columns: any[] = [
      { columnDef: 'totvs_field', header: 'Nome do Campo no TOTVS', dataName: row => `${row.totvs_field}` },
      { columnDef: 'crm_field', header: 'Correspondente no Rubeus', dataName: row => `${row.crm_field}` },
    ];
    public itensSelecionados: any[] = [];

    constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<DialogImportFieldsComponent>,
      private service: DataService,
      private router: Router,
      private crudFieldService: CrudFieldsService,
      private notice: NoticeComponent
    ) {
      this.dados = data;
      this.fields = this.dados.data
      this.payload = this.dados.payload
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  salvar() {
    const ids = this.itensSelecionados.map((item) => item.id);
    this.service.resolve('field/import', {fields: ids, ...this.payload}).then((data) => {
      if (data.success) {
        this.notice.showMessageSuccess("Campos importados com sucesso");
        this.crudFieldService.addRowData(this.itensSelecionados);
        this.dialogRef.close(data.data);
      } else {
        this.notice.showMessageError(data);
      }
    })
  }
}
